import {
  ChallengeAttempt,
  ChallengeHistory,
  DailyChallenge,
} from "../../types/challenges";
import { ChallengesActionTypes } from "../actions/challengeActions";

interface ChallengesState {
  dailyChallenges: Record<
    string,
    {
      challenge: DailyChallenge;
      myAttempt?: ChallengeAttempt;
    }
  >;
  myHistory?: ChallengeHistory;
  loading: boolean;
}
const initialState: ChallengesState = {
  dailyChallenges: {},
  myHistory: {
    streak: 0,
    longestStreak: 0,
    attempts: [],
  },
  loading: false,
};

export default function challenges(
  state = initialState,
  action: ChallengesActionTypes
): ChallengesState {
  switch (action.type) {
    case "SET_DAILY_CHALLENGE":
      return {
        ...state,
        dailyChallenges: {
          ...state.dailyChallenges,
          [action.payload.challenge.day]: {
            challenge: action.payload.challenge,
            myAttempt: action.payload.myAttempt,
          },
        },
      };
    case "SET_CHALLENGE_STATS":
      return {
        ...state,
        myHistory: action.payload.stats,
      };
    case "SET_CHALLENGES_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
}
